export const STOP_SALES = {
  ADD_BUTTON: 'Add stop sale',
  DELETE: 'Delete stop sale?',
  TOOLTIP:
    'Here you can add information about the specific period for which you want to block the booking of your vehicles.',
  CAR_CLASS_TOOLTIP:
    'Car class includes SIPP and Company class (e.g. EFAR-EFAR)',
  TYPE_TOOLTIP: {
    NOTE: 'Please note that you can only set a temporary stop sale.',
    SET_BY_ECONOMY_BOOKINGS:
      'A permanent stop sale can only be set by EconomyBookings.',
  },
}

export const STOP_SALES_ADD_CONFIRMATION = {
  CONFIRMATION_MODAL: {
    QUESTION: 'Are you sure you want to delete this stop sale?',
  },
  SUCCESS_MODAL: {
    TITLE: 'Stop sale was successfully deleted',
  },
}

export const STOP_SALE_SUCCESS_ADD = 'Stop sale has been successfully adding'
